export default __webpack_public_path__ + "static/media/TTNorms-Medium.b2ec1027.otf";